export const modules = {
  QUESTIONS_EDITOR: 'QUESTIONS_EDITOR',
  ACCOUNTING: 'ACCOUNTING',
  NOTIF_BANNER: 'NOTIF_BANNER',
  EMAILS: 'EMAILS',
  PERMISSIONS: 'PERMISSIONS',
  MACHINE_KEYS: 'MACHINE_KEYS',
  DEV_TEST: 'DEV_TEST',
  TRANSLATIONS_EDITOR: 'TRANSLATIONS_EDITOR',
  COOKIES_BAR: 'COOKIES_BAR',
  IMPORT_MAPPING: 'IMPORT_MAPPING',
  FILE_LOOKUPS: 'FILE_LOOKUPS',
  EMAIL_TEMPLATES: 'EMAIL_TEMPLATES',
  USERS: 'USERS',
  TOAST_CONTAINER: 'TOAST_CONTAINER',
  TRACKING: 'TRACKING',
  CHAT: 'CHAT',
  BRANDING: 'BRANDING',
  SITES: 'SITES',
};
